import {REPORT_RES_SET_LIST, REPORT_RES_CLEAR_LIST, REPORT_RES_SET_INFO,
  REPORT_REFUNDS_SET_LIST, REPORT_REFUNDS_CLEAR_LIST, REPORT_REFUNDS_SET_INFO, 
  REPORT_SALES_SET_LIST, REPORT_SALES_CLEAR_LIST, REPORT_SALES_SET_INFO} from '../constants/actionTypes';
import {ERR_COMMUNICATION, ERR_UNKNOWN} from '../constants/errors';
import {fetchMB} from '../utils/MojBus'
import {error} from './appActions'

export function setReportReservationsList(reservations, ticketUrlPath, filter){
  return {
    type: REPORT_RES_SET_LIST,
    reservations,
    ticketUrlPath,
    filter,    
  }
}
export function clearReportReservationsList(){
  return {
    type: REPORT_RES_CLEAR_LIST,    
  }
}

export function setReportReservationsInfoText(infoText){
  return {
    type: REPORT_RES_SET_INFO,
    infoText,
  }
}

export function fetchReportReservations(apiRequest){    
  return dispatch => {
           
    fetchMB('report', apiRequest, true)        
    .then(
      function(json){
        if (json.status==='OK'){  
          return dispatch(setReportReservationsList(json.reservations, json.ticketUrlPath, apiRequest))
        }
        else
        return dispatch(error(ERR_UNKNOWN))
      },
      function(errorNo){
        return dispatch(error(ERR_COMMUNICATION))
      }
    )
  }    
} 

export function setReportRefundsList(refunds, filter){
  return {
    type: REPORT_REFUNDS_SET_LIST,
    refunds,
    filter,    
  }
}
export function clearReportRefundsList(){
  return {
    type: REPORT_REFUNDS_CLEAR_LIST,    
  }
}

export function setReportRefundsInfoText(infoText){
  return {
    type: REPORT_REFUNDS_SET_INFO,
    infoText,
  }
}

export function fetchReportRefunds(apiRequest){    
  return dispatch => {    
    apiRequest.reportType='refunds'    
    fetchMB('report', apiRequest, true)        
    .then(
      function(json){
        if (json.status==='OK'){  
          return dispatch(setReportRefundsList(json.refunds, apiRequest))
        }
        else
          return dispatch(error(ERR_UNKNOWN))
      },
      function(errorNum){
        return dispatch(error(ERR_COMMUNICATION))
      }
    )
  }    
} 


export function setReportSalesList(sales, salesFilter){
  return {
    type: REPORT_SALES_SET_LIST,
    sales,    
    salesFilter
  }
}
export function clearReportSalesList(){
  return {
    type: REPORT_SALES_CLEAR_LIST,    
  }
}
export function setReportSalesInfoText(infoText){
  return {
    type: REPORT_SALES_SET_INFO,
    infoText,
  }
}

export function fetchReportSales(apiRequest){    
  return dispatch => {
    // let funcError=function(error){
    //   //return dispatch(error(ERR_UNKNOWN))
    //   alert('Error'+error)
    // }
    apiRequest.reportType='agentSummary'    
    fetchMB('report', apiRequest, true)        
    .then(
      function(json){
        //console.log(json)
        if (json.status==='OK'){  
          return dispatch(setReportSalesList(json.data, apiRequest))
        }
        else
          return dispatch(error(json))
          //funcError(json)
      },
      function(errorNo){        
        return dispatch(error(errorNo))
        //return dispatch(error(ERR_COMMUNICATION))
      }
    )
  }    
} 


// WEBPACK FOOTER //
// ./src/actions/reportActions.js